
var cmsFaq = vueIfExists({
  mixins: [win.toggleCollapse],
  el: '#cms-faq',
  methods: {}
});
